import _ from 'lodash';

export default {
  install(app) {
    // serach for files
    const baseComponents = require.context(
      '../components/base/',
      false,
      /[A-Za-z0-9-_,\s]+\.vue$/i
    ); // search on a group of files
    baseComponents.keys().forEach((fileName) => {
      const componentConfig = baseComponents(fileName);
      const componentName = _.upperFirst(
        _.camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
      );

      //   console.log(fileName, componentName);
      app.component(
        `Base${componentName}`,
        componentConfig.default || componentConfig
      );
    });
  },
};
